const BACKEND_PRICE_TYPES = new Set([
  "priced_at",
  "starting_at",
  "range",
  "donation",
  "rsvp",
  "door",
]);

const hasTicketPrice = (value) => Boolean(value && value !== "$");

export const isSubmitReadyTicket = (ticket) => {
  if (!ticket) return false;

  return (
    ticket.priceType === "donation" ||
    ticket.priceType === "rsvp" ||
    ticket.priceType === "door" ||
    hasTicketPrice(ticket.price) ||
    hasTicketPrice(ticket.priceMax)
  );
};

export const normalizeTicketForBackend = (ticket) => {
  if (!ticket) return ticket;

  const priceType = BACKEND_PRICE_TYPES.has(ticket.priceType) ? ticket.priceType : "priced_at";
  return { ...ticket, priceType };
};

export const normalizeTicketsForBackend = (tickets = []) =>
  tickets.filter(isSubmitReadyTicket).map(normalizeTicketForBackend);

export const normalizeEventTicketsInForm = (form) => {
  if (!form?.has?.("event")) return form;

  const event = JSON.parse(form.get("event") || "{}");
  if (Array.isArray(event.tickets)) {
    event.tickets = normalizeTicketsForBackend(event.tickets);
    form.set("event", JSON.stringify(event));
  }

  return form;
};
